import { useEffect, useState } from 'react';
import { ReactComponent as LogoTipo } from '../../imgs/logo.svg';
import './styles.css';

function Logo() {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 2000); 
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  

  return (
    <div className='logo'>
      <svg
        width="35"
        height="35"
        className={animate ? 'girar' : ''}
        viewBox="0 0 100 100"
      >
        <LogoTipo width={"100%"} height={"100%"} />
      </svg>
    </div>
  );
}

export default Logo;